import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { selectPageType } from '../../../selectors/page';
import { IMobileNavigationItem } from '../../../types/mobileBottomNavigation';
import { IApplicationState } from '../../../types/redux';
import { useApplicationContext } from '../../../utils/applicationContext';
import { IconMessage } from '../assets';
import { trackNavigationItemClick } from '../tracking';

export const useChatsNavigationItem = (): IMobileNavigationItem => {
  const {
    custom: { subdomain },
  } = useApplicationContext();

  const chatsLink = useSelector<IApplicationState, string>(
    state => state.servicesLinks.messages || /* istanbul ignore next */ `https://${subdomain}.cian.ru/dialogs/`,
  );

  const page = useSelector(selectPageType);

  const handleClick = useCallback(() => {
    trackNavigationItemClick('messages');
  }, []);

  return {
    title: 'Сообщения',
    link: chatsLink,
    icon: IconMessage,
    isActive: page === 'chats',
    onClick: handleClick,
  };
};
